<template>
  <section>
    <div class="listview__head">
      <div>
        <div class="c-lbl">Cuentas corrientes</div>
        <div class="listview__desc">
          {{ totales.total || 0 }} cuentas · Saldo total:
          <strong class="grad-text">{{ fmt(totales.saldo_total) }}</strong>
        </div>
      </div>
    </div>

    <div class="listview__filters">
      <input class="fi" v-model="filters.q" @input="debouncedFetch" placeholder="Buscar cliente..." />
      <select class="fi" v-model="filters.moneda" @change="fetch" style="max-width:130px">
        <option value="">Todas</option>
        <option value="ARS">ARS</option><option value="USD">USD</option><option value="EUR">EUR</option>
      </select>
      <label class="fx-ac" style="gap:6px;font-size:12.5px;color:var(--tx-md);cursor:pointer">
        <input type="checkbox" v-model="filters.con_saldo" @change="fetch" /> Solo con saldo
      </label>
    </div>

    <div class="card">
      <div class="tbl-wrap">
        <table class="tbl">
          <thead>
            <tr><th>Cliente</th><th>Tipo</th><th>CUIT</th><th>Moneda</th><th style="text-align:right">Saldo</th></tr>
          </thead>
          <tbody>
            <tr v-if="loading"><td colspan="5" class="tbl-empty">Cargando...</td></tr>
            <tr v-else-if="!items.length"><td colspan="5" class="tbl-empty">Sin cuentas corrientes.</td></tr>
            <tr v-for="cc in items" :key="cc.id">
              <td><strong style="color:var(--tx-hi)">{{ cc.cliente?.nombre || '—' }}</strong></td>
              <td><span class="pill pill-b">{{ cc.cliente?.tipo || '—' }}</span></td>
              <td class="mono">{{ cc.cliente?.cuit || '—' }}</td>
              <td>{{ cc.moneda }}</td>
              <td class="mono" style="text-align:right">
                <strong :class="{ 'grad-text': Number(cc.saldo) > 0 }">{{ fmt(cc.saldo, cc.moneda) }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="listview__pag" v-if="pagination.last_page > 1">
        <button class="btn btn-g btn-sm" :disabled="pagination.current_page <= 1" @click="go(pagination.current_page - 1)">‹ Anterior</button>
        <span>Página {{ pagination.current_page }} / {{ pagination.last_page }}</span>
        <button class="btn btn-g btn-sm" :disabled="pagination.current_page >= pagination.last_page" @click="go(pagination.current_page + 1)">Siguiente ›</button>
      </div>
    </div>
  </section>
</template>

<script>
import api from '../services/api';
export default {
  name: 'CuentasCorrientesView',
  data() {
    return {
      items: [], loading: false,
      totales: { total: 0, saldo_total: 0 },
      pagination: { current_page: 1, last_page: 1, total: 0 },
      filters: { q: '', moneda: '', con_saldo: false, page: 1 },
      _debounce: null
    };
  },
  async mounted() { await this.fetch(); },
  methods: {
    debouncedFetch() { clearTimeout(this._debounce); this._debounce = setTimeout(() => this.fetch(), 250); },
    async fetch() {
      this.loading = true;
      try {
        const { data } = await api.get('/cuentas-corrientes', { params: { ...this.filters, con_saldo: this.filters.con_saldo ? 1 : 0, per_page: 25 } });
        const p = data.data;
        this.items = p.data;
        this.totales = data.totales || { total: 0, saldo_total: 0 };
        this.pagination = { current_page: p.current_page, last_page: p.last_page, total: p.total };
      } catch (e) {
        if (!e?.isAuthExpired) console.warn('[CC]', e);
      } finally { this.loading = false; }
    },
    go(page) { this.filters.page = page; this.fetch(); },
    fmt(n, m='ARS') { return new Intl.NumberFormat('es-AR', { style:'currency', currency:m, maximumFractionDigits:0 }).format(Number(n||0)); }
  }
};
</script>
